angular.module('quattro.bmbo.admin.dashboard', [])
    .controller('BmboAdminDashboardController', function () {

    });
